import { render, staticRenderFns } from "./ContraventionList.vue?vue&type=template&id=1e28bfa6&"
import script from "./ContraventionList.vue?vue&type=script&lang=js&"
export * from "./ContraventionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports